import React, { useEffect } from 'react';


import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { getOrderDetails, getOrderDetailsContent } from '../api/orders';
import { AddressBookItem, OrderDetails, OrderItem } from '../core/global';
import { ErrorMessage } from './error-message';
import Loader from './loader';
import { ModalTitle } from './modal-title';
import { OrderSummary } from './order-summary';
import { OrderItemsSummaryTable } from './order-summary-table';
import { StyledMarkdown } from './typeface';


interface ActiveOrderModalProps {
  onClose: () => void
  orderId: string | number | null
}

export const ActiveOrderModal = ({
  onClose,
  orderId,
}: ActiveOrderModalProps) => {
  const [error, setError] = React.useState<string[]>([])
  const [loading, setLoading] = React.useState(false)
  const [orderDetails, setOrderDetails] = React.useState<OrderDetails | null>(null)
  const [orderItems, setOrderItems] = React.useState<OrderItem[] | null>(null)
  const [orderAddress, setOrderAddress] = React.useState<AddressBookItem[] | null>(null)

  const [orderSummary, setOrderSummary] = React.useState<string | null>(null)
  const [orderAddressSummary, setOrderAddressSummary] = React.useState<string | null>(null)
  const [orderItemsSummary, setOrderItemsSummary] = React.useState<string | null>(null)
  const [orderCostSummary, setOrderCostSummary] = React.useState<string | null>(null)
  
  useEffect(() => {
    setError([])
    setLoading(true)
    if (orderId) {
      const executeContent = async () => {
        const result = await getOrderDetailsContent({
          order_id: orderId,
        })
        if (result) {
          const {response, error, message} = result
          if (error !== 200) {
            setError(e=> [...e, message] as string[])
          } else {
            const { order_summary, order_address, order_items, order_cost_summary} = response
            setOrderSummary(order_summary)
            setOrderAddressSummary(order_address)
            setOrderItemsSummary(order_items)
            setOrderCostSummary(order_cost_summary)
          }
        }
      }
      const execute = async () => {
        const result = await getOrderDetails({
          order_id: orderId,
        })
        if (result) {
          const {response, error, message} = result
          if (error !== 200) {
            setError(e => [...e, `Order **#${orderId}** details could not be fetched. ${message}`])
          } else {
            const { order_items, order_address, order_details} = response
            setOrderAddress(order_address)
            setOrderItems(order_items)
            setOrderDetails(order_details)
            await executeContent()
          }
        }
        setLoading(false)
      }
      execute()
      
    }
  }, [orderId])

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <ModalTitle onClose={onClose}>Your order details</ModalTitle>
      <DialogContent>
        {loading ?
          <Loader small center />
          :
          <>
            <ErrorMessage message={error} />
            {orderDetails && 
              <>
                <h3>Order summary</h3>
                <OrderSummary orderDetails={orderDetails} />
              </>
            }

            {/* {orderSummary && <StyledMarkdown>
              {orderSummary}
            </StyledMarkdown>} */}

            
            <>
              <h3>Order delivery address</h3>
              {orderAddressSummary ?
                <StyledMarkdown>
                  {orderAddressSummary}
                </StyledMarkdown>
              :
                <p>N/A</p>
              }
            </>
            
            {(orderDetails && orderItems) && 
              <>
                <h3>Order items</h3>
                <OrderItemsSummaryTable orderDetails={orderDetails} data={orderItems} />
              </>
            }

            {/* {orderItemsSummary && <StyledMarkdown className={tableStyles.table}>
              {orderItemsSummary}
            </StyledMarkdown>} */}
            {/* <div className={styles.costSummaryTable}>
              {orderCostSummary && <StyledMarkdown className={tableStyles.table}>
                {orderCostSummary}
              </StyledMarkdown>}
            </div> */}
          </>
        }
      </DialogContent>
      <>
        <DialogActions sx={{justifyContent: 'flex-end', pb: 3, px: 3}}>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </>
    </Dialog>

  )
}
